import { HandsontableEditor } from "../../editors/handsontableEditor/index.mjs";
import { autocompleteRenderer } from "../../renderers/autocompleteRenderer/index.mjs";
export var CELL_TYPE = 'handsontable';
export var HandsontableCellType = {
  CELL_TYPE: CELL_TYPE,
  editor: HandsontableEditor,
  // displays small gray arrow on right side of the cell
  renderer: autocompleteRenderer
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/handsontableType/handsontableType.mjs
// module id = 1103
// module chunks = 1